import * as yup from 'yup'

const requireOneSelection = yup
  .array()
  .test('at-least-one-selected', 'At least one MCC, MID, or Chain ID must be selected.', function () {
    const { mccList, midList, chainList } = this.parent
    return mccList.length > 0 || midList.length > 0 || chainList.length > 0
  })

export const initialValues = {
  description: '',
  mccList: [],
  midList: [],
  chainList: [],
}

export const validationSchema = yup.object({
  description: yup.string().strict(true).required('Category description is required and cannot be empty.'),
  mccList: requireOneSelection,
  midList: requireOneSelection,
  chainList: requireOneSelection,
})
